<template>
  <div class="link">
    <el-tabs v-model="activeName"
      @tab-click="handleClick">
      <el-tab-pane label="友情链接"
        name="first">
        <div class="item"
          v-for="(item, key) in links"
          :key="key">
          <span @click="openLink(item)">{{item.name}}</span>
        </div>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
export default {
  name: 'FriendshipLinks',
  data() {
    return {
      activeName: 'first',
      links: [
        {
          name: '广东省财政厅',
          url: 'http://czt.gd.gov.cn/'
        },
        {
          name: '中国政府采购网',
          url: 'http://www.ccgp.gov.cn/'
        },
        {
          name: '广东省政府采购网',
          url: 'https://gdgpo.czt.gd.gov.cn/'
        },
        {
          name: '广州市政府采购网',
          url: 'https://gzg2b.gzfinance.gov.cn/gzgpimp/portalindex.do?method=goIndex'
        },
        {
          name: '深圳市政府采购网',
          url: 'http://zfcg.sz.gov.cn/'
        }
      ]
    };
  },
  components: {},
  mounted() {},
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    openLink(item) {
      window.open(item.url, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.link {
  text-align: center;
  font-size: 0;
  padding: 0 12px;
  margin-top: 3px;
  padding-bottom: 35px;
  /deep/.el-tabs {
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__item {
      font-size: 18px;
      color: #000;
      font-weight: 600;
      line-height: 40px;
    }
    .el-tabs__item.is-active {
      color: #000;
    }
    .el-tabs__active-bar {
      height: 3px;
      background-color: #013f99;
    }
    .el-tabs__nav-wrap::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #013f99;
      z-index: 1;
    }
  }
  .item {
    display: inline-block;
    vertical-align: middle;
    width: 20%;
    padding: 13px 0;
    span {
      font-size: 14px;
      color: #5e5a5a;
      line-height: 20px;
      cursor: pointer;
    }
  }
}
</style>

